<template>
  <div id="user">
    <div class="rightContent">
      <div class="tableheader"></div>
      <div class="listBlock">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="账号名称">
            <el-input class="iput" v-model="form.username" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="账号新密码">
            <el-input type="password" class="iput" v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码">
            <el-input type="password" class="iput" v-model="form.repassword"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit">立即修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "user",
  data() {
    return {
      form: {
        webid: '',
        username: '',
        password: '',
        repassword: ''
      },
      doing: false
    };
  },
  computed: {},
  created() {
    this.form.username = localStorage.loginAccount
    this.form.webid = localStorage.webid
  },
  methods: {
    onSubmit() {
      if (this.doing === true) {
        return false;
      }
      if (this.form.password == '') {
        alert('新密码不能为空')
        return false;
      }
      if (this.form.password !== this.form.repassword) {
        alert('两次输入密码必须一致')
        return false;
      }
      let dataLoadIng = this.openFullScreen();
      this.doing = true;
      let _this = this;
      let data = this.form;
      this.axios
        .post("/kaiSrv/mgr/changePassWord", this.formData(data))
        .then(function(response) {
          alert('修改成功，请退出后用新密码登录')
          _this.doing = false;
          setTimeout(() => {
            dataLoadIng.close();
          }, 500);
        });
    }
  }
};
</script>
<style  lang="scss">
  .listBlock{
    margin-top: 30px;
    .iput{
      width: 300px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/user.vue